import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";
import { ApiCommonParams } from "../../@types/apiTypes";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";
import { Schedule } from "../../@types/scheduleTypes";

// @response:
// {
//   "tuesday": [
//       {
//           "id": "946742400_946746000",
//           "start_time": "2000-01-01T16:00:00.000Z",
//           "end_time": "2000-01-01T17:00:00.000Z",
//           "weekday": "tuesday",
//           "schedule_slot": {
//               "id": 915,
//               "created_at": "2023-01-29T13:50:37Z",
//               "date": null,
//               "day_of_the_week": "tuesday",
//               "end_time": "2000-01-01T19:00:00Z",
//               "is_canceled": false,
//               "object_type": "ScheduleSlot",
//               "start_time": "2000-01-01T16:00:00Z",
//               "updated_at": "2023-01-29T13:50:37Z"
//           }
//       },
//       {
//           "id": "946746000_946749600",
//           "start_time": "2000-01-01T17:00:00.000Z",
//           "end_time": "2000-01-01T18:00:00.000Z",
//           "weekday": "tuesday",
//           "schedule_slot": {
//               "id": 915,
//               "created_at": "2023-01-29T13:50:37Z",
//               "date": null,
//               "day_of_the_week": "tuesday",
//               "end_time": "2000-01-01T19:00:00Z",
//               "is_canceled": false,
//               "object_type": "ScheduleSlot",
//               "start_time": "2000-01-01T16:00:00Z",
//               "updated_at": "2023-01-29T13:50:37Z"
//           }
//       },
//       {
//           "id": "946749600_946753200",
//           "start_time": "2000-01-01T18:00:00.000Z",
//           "end_time": "2000-01-01T19:00:00.000Z",
//           "weekday": "tuesday",
//           "schedule_slot": {
//               "id": 915,
//               "created_at": "2023-01-29T13:50:37Z",
//               "date": null,
//               "day_of_the_week": "tuesday",
//               "end_time": "2000-01-01T19:00:00Z",
//               "is_canceled": false,
//               "object_type": "ScheduleSlot",
//               "start_time": "2000-01-01T16:00:00Z",
//               "updated_at": "2023-01-29T13:50:37Z"
//           }
//       }
//   ]
// }
export function indexProposedAvailability(): Promise<ApiResponse> {
  return Axios.get("v1/tutors/proposed_schedules/availability");
}

// @param proposedSchedule
// {
//   "schedule_slots_attributes": [
//     {
//         "day_of_the_week": "friday",
//         "start_time": "12:00",
//         "end_time": "13:00"
//     }
// ]
// }
// response:
// {
//   "id": 28,
//   "all_affected_students_ids": [
//       34
//   ],
//   "created_at": "2023-01-30T15:02:32Z",
//   "object_type": "ScheduleRequestGroup",
//   "rejected_by": null,
//   "remianing_students_ids": [],
//   "resolved_students_ids": [],
//   "status": "approved",
//   "updated_at": "2023-01-30T15:02:32Z"
// }
export function createProposedAvailability(
  proposedSchedule: Schedule
): Promise<ApiResponse> {
  return Axios.post(
    "v1/tutors/schedule_request_groups",
    proposedSchedule
  );
}

// @param proposedSchedule
// {
//   "schedule_slots_attributes": [
//     {
//         "day_of_the_week": "friday",
//         "start_time": "12:00",
//         "end_time": "13:00"
//     }
// ]
// }
// @response:
// {
//   "id": 283,
//   "created_at": "2023-01-30T15:03:15Z",
//   "is_active": true,
//   "object_type": "ProposedSchedule",
//   "schedule_slots": [
//       {
//           "id": 1055,
//           "created_at": "2023-01-30T15:03:15Z",
//           "date": null,
//           "day_of_the_week": "friday",
//           "end_time": "2023-01-30T13:00:00Z",
//           "is_canceled": false,
//           "object_type": "ScheduleSlot",
//           "start_time": "2023-01-30T12:00:00Z",
//           "updated_at": "2023-01-30T15:03:15Z"
//       }
//   ],
//   "tutor": {
//       "id": 2,
//       "academic_level": "uneducated",
//       "birth_date": "1974-06-19",
//       "city": null,
//       "country": "Germany",
//       "created_at": "2022-07-20T17:57:38Z",
//       "first_name": "احمد  عبد الله احمد",
//       "full_name": "احمد  عبد الله احمد عصام  مدحت عصام جعفر عبد الرحمن جعفر",
//       "gender": "male",
//       "is_available": true,
//       "last_name": "جعفر عبد الرحمن جعفر",
//       "middle_name": "عصام  مدحت عصام",
//       "native_language": "english",
//       "object_type": "Tutor",
//       "occupancy_rate": 0,
//       "phone_number": "+201020301800",
//       "profile_picture_url": "http://lvh.me:3000/rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBWm89IiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--ccdd445cc26f05f5f76bb2ccfdee583ab5516446/6d6f3cc222aa7a7df4fb3b8105d3d310.png",
//       "sponsorship": [],
//       "updated_at": "2023-01-12T18:25:59Z"
//   },
//   "type": "ProposedSchedule",
//   "updated_at": "2023-01-30T15:03:15Z"
// }
export function createProposedRecitation(
  studentId: number,
  proposedSchedule: Schedule
): Promise<ApiResponse> {
  return Axios.post(
    `v1/tutors/students/${studentId}/proposed_schedules`,
    proposedSchedule
  );
}


export function getActiveRequestGroups(
): Promise<ApiResponse> {
  return Axios.get(
    "/v1/tutors/schedule_request_groups/active",
  );
}
